import {checkIfAllTutorialChaptersCompleted} from '../../configs/tutorial';

// Почему приглашение в бой с ботами показывается сейчас. Значения короткие и
// латиницей: они же уходят уровнем события в GameAnalytics
// (page:BotMatchPromoModal:mount:<reason>) — по ним видно, сколько
// приглашений это «сразу после обучения», а сколько — повторные напоминания
export const BOT_MATCH_PROMO_REASONS = {
  // Первый показ: обучение только что пройдено (см. botMatchPromoStorage)
  TUTORIAL_FINISHED: 'tutorial_finished',
  // Повторный: игрок так и не сыграл ни одной партии
  REMINDER: 'reminder',
};

/**
 * Показывать ли приглашение в первый бой с ботами (BotMatchPromoModal) и по
 * какой причине; null — не показывать.
 *
 * Это первая ступень воронки новичка: локальная партия против ботов, дальше
 * обычный сетевой матч (resolveOnlineMatchPromoReason), потом рейтинг
 * (resolveRankedMatchPromoReason). Поэтому зовем только того, кто не сыграл
 * НИ ОДНОГО матча — ни локального, ни сетевого: у кого партии уже были,
 * приглашать в «первый бой» не за чем, ему адресована следующая ступень.
 *
 * Обучение должно быть пройдено целиком: главы открываются по порядку, так
 * что «пройдена последняя» и «пройдены все» — одно и то же. Сразу после
 * прохождения (isPending) приглашение показывается без оглядки на суточную
 * паузу; дальше — не чаще раза в сутки (isDue).
 *
 * null в счетчиках означает «счетчик неизвестен» (гость, старый сервер) —
 * тогда молчим, чтобы не звать в «первый» бой того, кто давно играет.
 *
 * @param {Object} params
 * @param {string[]} params.completedTutorialChapters - id пройденных глав из профиля
 * @param {number|null} params.localGamesPlayed - сыгранные локальные партии
 * @param {number|null} params.onlineGamesPlayed - сыгранные сетевые матчи
 * @param {boolean} params.isPending - обучение только что пройдено, приглашение еще не показано
 * @param {boolean} params.isDue - суточная пауза с прошлого показа прошла
 * @returns {string|null} причина из BOT_MATCH_PROMO_REASONS или null
 */
export const resolveBotMatchPromoReason = ({
  completedTutorialChapters,
  localGamesPlayed,
  onlineGamesPlayed,
  isPending,
  isDue,
}) => {
  if (!checkIfAllTutorialChaptersCompleted(completedTutorialChapters)) {
    return null;
  }
  if (localGamesPlayed !== 0 || onlineGamesPlayed !== 0) {
    return null;
  }
  if (isPending) {
    return BOT_MATCH_PROMO_REASONS.TUTORIAL_FINISHED;
  }
  if (isDue) {
    return BOT_MATCH_PROMO_REASONS.REMINDER;
  }
  return null;
};
